import { useState, useEffect, useRef, FC } from 'react';
import cn from 'clsx';

import usePreventScroll from '../../../hooks/usePreventScroll';
import { useStyles } from './Drawer.style';
import type { DrawerProps } from './types';
import { useDrawerContentAtom, useDrawerStateAtom } from './atoms';
import { DrawerNav } from './DrawerContent/const';

const Drawer: FC<DrawerProps> = ({ open = false, children: sideBarChildren }) => {
    const { setDrawerState } = useDrawerStateAtom();
    const { drawerContent } = useDrawerContentAtom();
    const onSetOpen = (status: boolean) => setDrawerState(status);
    const [sidebarWidth, setSidebarWidth] = useState<number>(0);
    const sidebarRef = useRef(null);

    useEffect(() => {
        saveSidebarWidth();
    }, []);

    usePreventScroll();

    const saveSidebarWidth = () => {
        const width = sidebarRef?.['current']?.['offsetWidth'];
        if (width !== sidebarWidth) {
            setSidebarWidth(width);
        }
    };

    const onOverlayClicked = () => {
        if (open) {
            onSetOpen(false);
        }
    };

    const classes = useStyles();
    const sidebarClass = cn(classes.sidebar, {
        [classes.sidebarFullWidth]: drawerContent !== DrawerNav.DEFAULT_NAVIGATION,
        [classes.sidebarIsOpen]: open,
    });
    const overlayClass = cn(classes.overlay, open && classes.overlayIsOpen);

    return (
        <div>
            <div className={sidebarClass} ref={sidebarRef} data-testid="drawer-sidebar">
                {sideBarChildren}
            </div>
            <div className={overlayClass} onClick={onOverlayClicked} />
        </div>
    );
};

export default Drawer;
